module.exports = __webpack_public_path__ + "img/yishi6.466a7025.jpg";